import { BaseService, RequestType } from "@intech/react-service";

class Listas extends BaseService {

  constructor() {
    super("listas");
  }

  ListarFundacaoEmpresaPlano = () =>
    this.CreateRequest<any>(RequestType.GET, "fundacaoEmpresaPlano");
}

export const ListasService = new Listas();